// removed by extract-text-webpack-plugin
module.exports = {"isOpen":"Modal__isOpen__2TLKc","scrollLayer":"Modal__scrollLayer__1CoRC","container":"Modal__container__34dVb","content":"Modal__content__27su4","isClosed":"Modal__isClosed__1hkpo","header":"Modal__header__1nqRV","home":"Modal__home__CVJFU","logo":"Modal__logo__3Y4ZJ","close":"Modal__close__10tWW","closeText":"Modal__closeText__1JBRj","closeIcon":"Modal__closeIcon__34RPE","closeLight":"Modal__closeLight__A723p"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.css
// module id = 2032
// module chunks = 0